import { render, staticRenderFns } from "./VERTICAL_SPACE.vue?vue&type=template&id=b7f11c72&scoped=true&"
import script from "./VERTICAL_SPACE.vue?vue&type=script&lang=js&"
export * from "./VERTICAL_SPACE.vue?vue&type=script&lang=js&"
import style0 from "./VERTICAL_SPACE.vue?vue&type=style&index=0&id=b7f11c72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7f11c72",
  null
  
)

export default component.exports